import type { AxiosRequestConfig, AxiosInstance } from "axios";
import axios from "axios";

export interface ResponseUtils<T> {
  code: HttpStatus;
  data: T;
  message: string;
}

export interface HttpConfig {
  baseUrl: string;
  headers?: AxiosRequestConfig["headers"];
  setHeaders?: () => AxiosRequestConfig["headers"];
  fail?: (err: unknown) => void;
}

export enum HttpStatus {
  Success = 1,
  Fail = 0,
}

export class Http {
  axiosInstance: AxiosInstance;
  params: HttpConfig;
  constructor(params: HttpConfig) {
    this.params = params;
    this.axiosInstance = axios.create({
      baseURL: params.baseUrl,
      timeout: 120 * 1000,
    });
  }

  request(config: AxiosRequestConfig) {
    if (config.headers && config.headers.responseType !== void 0) {
      config.responseType = config.headers.responseType;
    }

    const { filename: FILE_NAME, ...headers } = config.headers || {};
    config.headers = {
      ...(this.params.headers || {}),
      ...this.params.setHeaders?.(),
      ...headers,
    };

    return new Promise<any>((resolve, reject) => {
      this.axiosInstance<any>(config)
        .then((res) => {
          if (res?.config?.responseType === "blob") {
            const url = window.URL.createObjectURL(res.data);
            const a = document.createElement("a");
            a.setAttribute("style", "display: none");
            a.download = FILE_NAME || "下载";
            a.href = url;
            a.click();
            window.URL.revokeObjectURL(url);
            a.remove();
            return resolve(true);
          }

          // markdown特殊结构
          if (res.data?.content) {
            return resolve(res.data.content);
          }

          if (res.data.code === HttpStatus.Success) {
            resolve(res.data.data);
          } else {
            this.params.fail?.(res);
            reject(null);
          }
        })
        .catch((err) => {
          this.params.fail?.(err);
          reject(null);
        });
    });
  }

  get(url: string, params?: unknown, headers?: AxiosRequestConfig["headers"]) {
    return this.request({ method: "get", url, headers, params });
  }

  post(
    url: string,
    data?: unknown,
    params?: unknown,
    headers?: AxiosRequestConfig["headers"],
  ) {
    return this.request({ method: "post", url, headers, params, data });
  }

  put(
    url: string,
    data?: unknown,
    params?: unknown,
    headers?: AxiosRequestConfig["headers"],
  ) {
    return this.request({ method: "put", url, headers, params, data });
  }

  delete(
    url: string,
    params?: unknown,
    data?: unknown,
    headers?: AxiosRequestConfig["headers"],
  ) {
    return this.request({ method: "delete", url, headers, params, data });
  }
}
